import { useSelector } from 'react-redux';
import { Recipient } from '@dev/ee-api/ee-api-models';

import { getLogsStore } from '@api/store/logs/actions';

export const useSmsData = (msgId): Recipient => {
    const { logList } = useSelector(getLogsStore);

    const recipients: Recipient[] = logList?.Recipients;
    return recipients?.find((el: Recipient) => el.MsgID === msgId);
};
